/* unplugin-vue-components disabled */
import {ROLES} from 'consts/roles'
import Role from '../role.vue'
import {markRaw} from 'vue'

export default {
  components: {
    Role
  },
  mixins: [ModelValue(Array)],
  data() {
    return {
      ROLES: markRaw(ROLES),
    }
  },
  methods: {
    toggleRole(type) {
      const index = this.value.indexOf(type)
      if (index > -1) {
        this.value.splice(index, 1)
      } else {
        this.value.push(type)
      }
    },
    isSelected(type) {
      return this.value.includes(type)
    }
  }
}
